import { UIText2, IconPhone16 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './ContactsDisclaimer.css';

export const ContactsDisclaimer = () => {
  return (
    <div className={styles['disclaimer']}>
      <IconPhone16 />
      <UIText2>Номер только для звонков, сообщения не дойдут</UIText2>
    </div>
  );
};
